import React from 'react';

export default function Instructions({classes}) {
  return (
    <p className={classes}>The Poolside Visualizer makes the liner selection process fun and easy. Start by selecting from either the freeform or rectangular pool shape, then choose from our collection of liner designs, and surrounding deck surfaces. Build and compare liner designs and decking options to visualize your dream pool. Then download a report of your visualizer combination to share with your pool builder.</p>
  );
}
